// src/Login.js
import React, { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import logo from './s2e.png';

const API = 'https://snap2excel-backend.onrender.com';

function Login({ onLogin }) {
  const [email, setEmail] = useState('demo@snap2excel.com');
  const [password, setPassword] = useState('demo1234');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!onLogin) return;

    setError('');
    setLoading(true);

    const ok = await onLogin(email, password);
    setLoading(false);

    if (ok) {
      navigate('/app');
    } else {
      setError('Login failed. Check your email/password.');
    }
  };

  const handleGuest = async () => {
    if (!onLogin) return;

    setError('');
    setLoading(true);

    const ok = await onLogin('demo@snap2excel.com', 'demo1234');
    setLoading(false);

    if (ok) {
      navigate('/app');
    } else {
      setError('Guest login failed. Demo account not found.');
    }
  };

  return (
    <div className="auth-root">
      <div className="auth-card">
        <div className="auth-logo-wrap">
          <img src={logo} alt="Snap2Excel" className="auth-logo" />
        </div>

        <h1 className="auth-title">Welcome back</h1>
        <p className="auth-subtitle">
          Log in to see your receipts and dashboard.
        </p>

        {error && <p className="auth-error">{error}</p>}

        <form className="auth-form" onSubmit={handleSubmit}>
          <label className="auth-label">
            Email
            <input
              type="email"
              className="auth-input"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
            />
          </label>

          <label className="auth-label">
            Password
            <input
              type="password"
              className="auth-input"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
            />
          </label>

          <button
            type="submit"
            className="auth-btn-primary"
            disabled={loading}
          >
            {loading ? 'Logging in…' : 'Login'}
          </button>
        </form>

        <button
          type="button"
          className="auth-btn-secondary"
          onClick={handleGuest}
          disabled={loading}
        >
          {loading ? 'Please wait…' : 'Continue as Guest'}
        </button>

        <p className="auth-footer">
          No account yet?{' '}
          <Link to="/register" className="auth-link">
            Create account
          </Link>
        </p>
      </div>
    </div>
  );
}

export default Login;
